var appCtrlServiceModule = angular.module('AppCtrl.service', ['AppCtrl.jobvite.service', 'jv.Common.Loading']);

// Define constants
appCtrlServiceModule.value('CONST', {
	Urls: {
		getJobvites: window.jvUrls.source + '/action/user/jobvites/list',
		summary: window.jvUrls.source + '/action/user/jobvites/summary',
		apps: window.jvUrls.source + '/action/user/jobvites/apps'
	}
});

//Define service to fetch the jobvites.
appCtrlServiceModule.factory('getJobvites', ['$http', 'CONST', function ($http, CONST) {
	return function (args, ajaxCallType) {
		if (typeof args === 'undefined') {
			args = {};
		}
		if (args.startDate === null || args.startDate === undefined || args.startDate.trim() === '') {
			delete args.startDate;
		}
		if (args.endDate === null || args.endDate === undefined || args.endDate.trim() === '') {
			delete args.endDate;
		}
		var _data = args;
		var _type = 'GET';
		var _ajaxCall = '';
		delete _data.type;

		var _httpObject = {};
		_httpObject.headers = {
			'Content-Type': 'application/x-www-form-urlencoded'
		};
		_httpObject.method = _type;
		_httpObject.url = !!args.url ? args.url : CONST.Urls.getJobvites;
		_httpObject.params = _data;

		if (_httpObject.url === CONST.Urls.getJobvites) {
			_ajaxCall = 'getJobvites';
		} else if (ajaxCallType && ajaxCallType.trim() !== '') {
			_ajaxCall = ajaxCallType;
		}

		if (typeof _gaq !== 'undefined') {
			_gaq.push(['_trackEvent', window.JV.PAGE_TYPE, _ajaxCall, window._jvselfUser.companyEId]);
		}

		return $http(_httpObject);
	};
}]);

//Define service to fetch the metrics.
appCtrlServiceModule.factory('getMetrics', ['$http', 'CONST', function ($http, CONST) {
	return function (args) {
		if (typeof args === 'undefined') {
			args = {};
		}
		var _data = args;
		var _type = 'GET';

		delete _data.type;

		var _httpObject = {};
		_httpObject.headers = {
			'Content-Type': 'application/x-www-form-urlencoded'
		};
		_httpObject.method = _type;
		_httpObject.url = CONST.Urls.summary;
		_httpObject.params = _data;

		if (typeof _gaq !== 'undefined') {
			_gaq.push(['_trackEvent', window.JV.PAGE_TYPE, 'getMetrics', window._jvselfUser.companyEId]);
		}
		return $http(_httpObject);
	};
}]);

// Service Exposed to all the controllers for getting and navigating through all the jobvites.
appCtrlServiceModule.factory('jobviteService', ['getJobvites', 'getMetrics', '$rootScope', function (getJobvites, getMetrics, $rootScope) {
	var jobviteService = {};
	jobviteService.filters = {};
	jobviteService.sortyBy = '';
	jobviteService.inMessageIds = [];
	jobviteService.sentMessageIds = [];
	var todaysDate = new Date();
	//var tDate = (todaysDate.getMonth() + 1)+ '/' + todaysDate.getDate() + '/' + (todaysDate.getFullYear());
	//var yDate = (todaysDate.getMonth() + 1)+ '/' + todaysDate.getDate() + '/' + (todaysDate.getFullYear()-1);

	//jobviteService.filters.startDate = yDate;
	//jobviteService.filters.endDate = tDate;

	jobviteService.getMetrics = function () {
		var _getMetrics = getMetrics();
		_getMetrics.then(function (results) {
			$rootScope.$broadcast('metricsResults', results.data);
		});
	};

	jobviteService.getJobvites = function () {
		var _getJobvites = getJobvites(this.filters);
		_getJobvites.then(function (results) {
			$rootScope.$broadcast('messageResults', results.data);
		});
	};

	jobviteService.getSentJobvites = function (args, ajaxCallType) {
		var _getJobvites = getJobvites(args, ajaxCallType);
		_getJobvites.then(function (results) {
			$rootScope.$broadcast('showDeleteDialog', results.data);
		});
	};

	jobviteService.getJobs = function (args, ajaxCallType) {
		var _getJobvites = getJobvites(args, ajaxCallType);
		_getJobvites.then(function (results) {
			$rootScope.$broadcast('showJobs', results.data);
		});
	};

	jobviteService.setPage = function (page) {
		this.page = page;
		this.filters.page = this.page;
		this.broadcastUpdateResults();
	};

	jobviteService.setSortBy = function (key) {
		this.sortBy = key;
		this.setFilters(this.filters);
	};


	jobviteService.getSelectedMessageIds = function () {
		if (this.filters.folderType && this.filters.folderType === 'sent') {
			return this.sentMessageIds;
		} else {
			return this.inMessageIds;
		}
	};

	jobviteService.checkAllCheckboxes = function (checked) {
		$rootScope.$broadcast('checkUncheck', checked);
	};

	jobviteService.setPaginationVariables = function (args) {
		this.total = args.total;
		this.page = args.page;
		this.pageCount = args.pageCount;
		this.broadcastResultCount();
	};

	// set up by the filter controller. Used for setting the left panel filters.
	jobviteService.setFilters = function (args) {
		this.page = 0;
		this.broadcastPageReinitialization();
		this.filters = angular.copy(args);
		if (this.filters.channel === null || this.filters.channel === undefined || (this.filters.channel.trim() === '')) {
			delete this.filters.channel;
		}
		if (this.filters.messageType === null || this.filters.messageType === undefined || (this.filters.messageType.trim() === '')) {
			delete this.filters.messageType;
		}
		this.broadcastUpdateResults();
	}

	// broadcast the message to the header controller .
	jobviteService.broadcastResultCount = function () {
		$rootScope.$broadcast('paginationBroadcast');
	};

	jobviteService.broadcastPageReinitialization = function () {
		$rootScope.$broadcast('updatePage');
	}

	jobviteService.broadcastUpdateResults = function () {
		$rootScope.$broadcast('updateMessages', this.page);
	}

	return jobviteService;
}]);

//Define service to fetch the apps.
appCtrlServiceModule.factory('getRefApps', ['$http', 'CONST', function ($http, CONST) {
	return function (args, ajaxCallType) {
		if (typeof args === 'undefined') {
			args = {};
		}
		if (args.startDate === null || args.startDate === undefined || args.startDate.trim() === '') {
			delete args.startDate;
		}
		if (args.endDate === null || args.endDate === undefined || args.endDate.trim() === '') {
			delete args.endDate;
		}
		var _data = args;
		var _type = 'GET';
		var _ajaxCall = '';
		delete _data.type;

		var _httpObject = {};
		_httpObject.headers = {
			'Content-Type': 'application/x-www-form-urlencoded'
		};
		_httpObject.method = _type;
		_httpObject.url = !!args.url ? args.url : CONST.Urls.apps;
		_httpObject.params = _data;

		if (_httpObject.url === CONST.Urls.apps) {
			_ajaxCall = 'getReferralApplications';
		}

		if (typeof _gaq !== 'undefined') {
			_gaq.push(['_trackEvent', window.JV.PAGE_TYPE, _ajaxCall, window._jvselfUser.companyEId]);
		}

		return $http(_httpObject);
	};
}]);


//Define service to add a comment.
appCtrlServiceModule.factory('addComment', ['$http', 'CONST', function ($http, CONST) {
	return function (args) {
		var _data = {
			comment: args.comment
		};
		var _httpObject = {};
		_httpObject.headers = {
			'Content-Type': 'application/x-www-form-urlencoded'
		};
		_httpObject.method = 'POST';
		_httpObject.url = CONST.Urls.apps + '/' + args.EId + '/comments';
		_httpObject.params = _data;

		if (typeof _gaq !== 'undefined') {
			_gaq.push(['_trackEvent', window.JV.PAGE_TYPE, 'addComment', window._jvselfUser.companyEId]);
		}
		return $http(_httpObject);
	};
}]);
// Service Exposed to all the controllers for getting and navigating through all the referral apps.
appCtrlServiceModule.factory('refAppService', ['getRefApps', 'addComment', '$rootScope', function (getRefApps, addComment, $rootScope) {
	var refAppService = {};
	refAppService.filters = {};

	var todaysDate = new Date();

	refAppService.addComment = function (args, callback) {
		var _addedComment = addComment(args);
		_addedComment.then(function (results) {
			callback(results.data);
		});
	};

	refAppService.getRefApps = function () {
		var _getRefApps = getRefApps(this.filters);
		_getRefApps.then(function (results) {
			$rootScope.$broadcast('messageResults', results.data);
		});
	};

	refAppService.setPage = function (page) {
		this.page = page;
		this.filters.page = this.page;
		this.broadcastUpdateResults();
	};

	refAppService.setPaginationVariables = function (args) {
		this.total = args.total;
		this.page = args.page;
		this.pageCount = args.pageCount;
		this.broadcastResultCount();
	};

	// set up by the filter controller. Used for setting the left panel filters.
	refAppService.setFilters = function (args) {
		this.page = 0;
		this.broadcastPageReinitialization();
		this.filters = angular.copy(args);
		this.broadcastUpdateResults();
	}

	// broadcast the message to the header controller .
	refAppService.broadcastResultCount = function () {
		$rootScope.$broadcast('paginationBroadcast');
	};

	refAppService.broadcastPageReinitialization = function () {
		$rootScope.$broadcast('updatePage');
	}

	refAppService.broadcastUpdateResults = function () {
		$rootScope.$broadcast('updateMessages', this.page);
	}
	return refAppService;
}]);

angular.module('AppCtrl.directive', ['AppCtrl.service', 'JV.Core.Directives', 'jv.services', 'jv.Common.Directives.Datepicker']).
directive('jvDateNgmodel', ['$filter', function ($filter) {
	return {
		require: '?ngModel',
		restrict: 'A',
		link: function (scope, element, attr, ngModel) {
			if (!ngModel) {
				return;
			}

			// Called when the view needs to be updated.
			ngModel.$render = function () {
				element.val(ngModel.$viewValue);
			};

			$(element).on('change', function (e) {
				scope.$apply(setValue);
			});

			//sets the value of the ng-model
			function setValue() {
				ngModel.$setViewValue(element.val());
			}
		}
	}
}]);


angular.module('AppCtrl.filter', ['jv.Common.Filters']);


//main module.
var appController = angular.module('AppCtrl', ['AppCtrl.service', 'AppCtrl.filter', 'AppCtrl.directive', 'jv.Common.Modal', 'jv.Common.Filters', 'jobviteListModule', 'referApplicationModule']);
appController.value('modalTemplateUrl', '../TalentNetwork/htm/contact2/modal.html');
appController.config(['$locationProvider', function($locationProvider) {
	$locationProvider.hashPrefix('');
}]);

//Application controller
appController.controller('MainCtrl', ['$scope', '$location', '$rootScope', '$window', 'jvContextualLoadingService',
	function ($scope, $location, $rootScope, $window, jvContextualLoadingService) {
		// This is the function that will be called for the child controllers for date conversions.
		$scope.getMilliseconds = function (dateVal) {
			if (dateVal && dateVal !== '-') {
				var d = new Date(dateVal);
				return d.getTime();
			} else {
				return dateVal;
			}
		};


		$scope.modals = {
			viewComment: false,
			addComment: false
		};

		$scope.$on('openAddCommentModal', function (event, text, EId, index) {
			$rootScope.$broadcast('setComment', text, EId, index);
			showModal('addComment');
		});

		$scope.$on('openViewCommentModal', function (event, text, EId, index) {
			$rootScope.$broadcast('setComment', text, EId, index);
			showModal('viewComment');
		});

		$scope.hideModals = function () {
			angular.forEach($scope.modals, function (val, key) {
				$scope.modals[key] = false;
			});
			$scope.$broadcast('COMMENT_HIDING_MODAL');
		}

		function showModal(modal, text) {
			$scope.modals[modal] = true;
		}

		$scope.$on('COMMENT_MODAL_HIDE_ALL', function (event, nessage) {
			$scope.hideModals();
		});

		if ($location.path() === '/refApp') {
			$scope.isSelected = {
				'jobvite': '',
				'referral': 'jv-currentTab'
			};
		} else {
			$scope.isSelected = {
				'jobvite': 'jv-currentTab',
				'referral': ''
			};
		}

		$scope.switchTabs = true;

		//Change this to a module and use routes to configure tabs : NV
		$scope.getInclude = function () {
			if ($scope.isSelected.referral === 'jv-currentTab') {
				return '/TalentNetwork/jobvite/refApplications.html';
			} else {
				return '/TalentNetwork/jobvite/jobviteTab.html';
			}

		}

		$scope.openReferralApp = function () {
			$location.path('refApp');
			$scope.isSelected = {
				'jobvite': '',
				'referral': 'jv-currentTab'
			};
		}

		$scope.openJobvites = function () {
			$window.location.href = $window.location.href.split('#')[0];
		}

		$scope.flags = {
			showGridLoader: false
		};
		$scope.$watch('flags.showGridLoader', function (val) {
			if (val) {
				jvContextualLoadingService.show('gridLoader');
			} else {
				jvContextualLoadingService.hide('gridLoader');
			}
		});
	}
]);

var JV = window.JV || {};
JV.Modal = {
	modalRef: null,
	initialize: function (elementId) {
		// Initialize the modal dialog.
		$.jqm.params.modal = true;
		this.modalRef = $('#' + elementId);
		this.modalRef.jqm();
		this.attachEvent();
	},

	attachEvent: function () {
		var me = this;
		$('button[KEY="CLOSE"]').on('click', function () {
			me.hide();
		});
	},

	showAtHeight: function () {
		this.modalRef.jqmShowAtHeight();
	},

	show: function () {
		this.modalRef.jqmShow();
	},

	// Hide the modal.
	hide: function () {
		this.modalRef.jqmHide();
	},

	// Hide the modal and remove the contents..
	remove: function () {
		this.modalRef.jqmHide();
		this.modalRef.content('');
	}
};


JV.ModalJob = {
	modalRef: null,
	initialize: function (elementId) {
		// Initialize the modal dialog.
		$.jqm.params.modal = true;
		this.modalRef = $('#' + elementId);
		this.modalRef.jqm();
		this.attachEvent();
	},

	attachEvent: function () {
		var me = this;
		$('button[KEY="CLOSE"]').on('click', function () {
			me.hide();
		});
	},

	show: function () {
		this.modalRef.jqmShow();
	},

	// Hide the modal.
	hide: function () {
		this.modalRef.jqmHide();
	},

	// Hide the modal and remove the contents..
	remove: function () {
		this.modalRef.jqmHide();
		this.modalRef.content('');
	}
};